PT.AsyncSection = class AsyncSection
  constructor: (@section)->
    @load(@section)

  load: (section) ->
    retry = true

    $.get(section.getAttribute("data-async-url"),
      section_id: section.getAttribute("data-section-id")
    ).fail ->
      # request failed, so retry
      # one time after a small delay
      if retry
        setTimeout =>
          $.ajax @
          retry = false
        , 1000
